module.exports = __webpack_public_path__ + "img/logo.4cf4d344.jpg";